/**
 * Meta campaign detail page.
 *
 * As of A3.5, this route delegates to the shared `Campaign` page
 * component, which detects `platform_source` on the loaded campaign
 * and renders the appropriate per-card content (Performance Metrics,
 * Campaign Structure, Landing Pages, Manage Campaign). The route stays
 * separate from `/google-campaign/:id` and `/campaign/:id` for URL
 * clarity; Phase C will converge them.
 */
import { Campaign } from '@/pages/Campaign';

export function MetaCampaign() {
  return <Campaign />;
}
